

import axios from 'axios'
import { EventTypes } from 'redux-segment'

export function fetchDataViews(companyParam,siteParam) {
  return (dispatch, getState) => {
    dispatch({
      type: 'DATA_VIEWS_FETCH',
      payload: axios(`/companies/${companyParam}/sites/${siteParam}/data_views`)
    })
  }
}
export function setDataViewSummary(dataViewSummary) {
  return (dispatch, getState) => {
    dispatch({
      type: 'DATA_VIEW_SUMMARY_SET',
      meta: {
        dataViewSummary: dataViewSummary
      }
    })
  }
}
export function setAddManualInputFormVisibility(visible) {
  return (dispatch, getState) => {
    dispatch({
      type: 'DATA_VIEW_ADD_MANUAL_INPUT_FORM_VISIBLE',
      meta: {
        visible: visible
      }
    })
  }
}
export function fetchDataView(companyParam,siteParam,dataViewParam) {
  return (dispatch, getState) => {
    dispatch({
      type: 'DATA_VIEW_FETCH',
      payload: axios(`/companies/${companyParam}/sites/${siteParam}/data_views/${dataViewParam}`)
    })
  }
}
export function fetchDataViewHash(companyParam,siteParam,dataViewParam) {
  return (dispatch, getState) => {
    dispatch({
      type: 'DATA_VIEW_HASH_FETCH',
      payload: axios(`/companies/${companyParam}/sites/${siteParam}/data_views/${dataViewParam}/data_view_hash`)
    })
  }
}

export function updateDataViewConfigHash(companyParam,siteParam,dataViewParam,updateParams) {
  return (dispatch, getState) => {
    dispatch({
      type: 'DATA_VIEW_UPDATE_CONFIG_HASH',
      payload: axios.put(`/companies/${companyParam}/sites/${siteParam}/data_views/${dataViewParam}/config_hash`,updateParams)
    })
  }
}

// export function updateDataViewHash(siteId,dataViewGroupId,params) {
//   return (dispatch, getState) => {
//     dispatch({
//       type: 'DATA_VIEW_HASH_UPDATE',
//       payload: axios.put(`/sites/${siteId}/data_views/${dataViewGroupId}`)
//     })
//   }
// }



// WEBPACK FOOTER //
// ./src/actions/DataViewActions.js